import './instagram_message.js.coffee'
Namespace 'Models'

class Models.InstagramMessageMedia extends Models.InstagramMessage
  constructor: (builder) ->
    super(builder)
    @attachments = builder.attachments

  accepts: (visitor) ->
    visitor.visit_instagram_message_media(@)

  getType: ->
    'media'
